<template>
  <div class="registry-box">
    <div class="top-icon">
      <img src="@/assets/logo_gold.png" @click.stop="toHome" />
    </div>
    <div class="user-pannel" :style="userPannelStyle">
      <div class="re-title">Join Covey.</div>
      <div class="re-sub-title">
        Get access to millions of study documents, 24/7 tutor help, textbook
        solutions, and more.
      </div>
      <div class="re-status">
        <div
          class="re-choice"
          :class="{ selected: usertype === 0 }"
          @click="chooseUserType(0)"
        >
          I'm a student
        </div>
        <div
          class="re-choice"
          :class="{ selected: usertype === 1 }"
          @click="chooseUserType(1)"
        >
          I'm a group
        </div>
      </div>

      <div v-if="usertype === 0 && registryStuType === 0">
        <div class="re-google re-third" @click.stop="logInGoogle">
          <img src="@/assets/icon/google.png" />Sign up with Google
        </div>
        <div class="re-facebook re-third" @click.stop="logInFacebook">
          <img src="@/assets/icon/facebook.png" />Sign up with Facebook
        </div>
        <div class="re-email re-third" @click="gotoEmail(1)">
          <img src="@/assets/icon/email.png" />Sign up with Email
        </div>
      </div>

      <div v-if="usertype === 0 && registryStuType === 1">
        <el-form
          :model="emailRegistryForm"
          ref="emailRegistryForm"
          :rules="rules"
        >
          <el-form-item
            label="Email address"
            prop="login_name"
            v-if="
              registerInfo.registrytype !== '2' &&
              registerInfo.registrytype !== '3'
            "
          >
            <el-input
              v-model.trim="emailRegistryForm.login_name"
              placeholder="Enter an email address"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Create password"
            prop="password"
            v-if="
              registerInfo.registrytype !== '2' &&
              registerInfo.registrytype !== '3'
            "
          >
            <el-input
              type="password"
              v-model.trim="emailRegistryForm.password"
              placeholder="Enter your password"
            >
              <i
                slot="suffix"
                class="el-icon-view"
                style="margin-right: 5px"
                @mousedown="showPass($event)"
                @mouseup="hidePass($event)"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item
            label="Last Name"
            v-if="
              registerInfo.registrytype === '2' ||
              registerInfo.registrytype === '3'
            "
          >
            <el-input
              v-model.trim="registerInfo.last_name"
              placeholder="Enter an email address"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="First Name"
            v-if="
              registerInfo.registrytype === '2' ||
              registerInfo.registrytype === '3'
            "
          >
            <el-input
              v-model.trim="registerInfo.first_name"
              placeholder="Enter an email address"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="Your school" prop="schoolId">
            <el-select
              v-model="emailRegistryForm.schoolId"
              placeholder="Select your school name"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div
          class="re-create re-third"
          @click="registry"
          v-loading="registLoading"
        >
          Create my account
        </div>
      </div>
      <div class="re-group" v-if="usertype === 1">
        <el-form
          :model="groupRegistryForm"
          ref="groupRegistryFormRef"
          class="group-form"
          :rules="groupRegistryFormRules"
        >
          <div class="group-form-box">
            <div class="group-info-title">Society information</div>
            <el-form-item label="Society name" prop="societyName">
              <el-input
                v-model="groupRegistryForm.societyName"
                placeholder="Official name registered at the school"
              ></el-input>
            </el-form-item>
            <el-form-item label="Society Introduction" prop="maincontent">
              <el-input
                v-model="groupRegistryForm.maincontent"
                type="textarea"
                placeholder="Enter Society Introduction"
                :maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="Community email(login_name)" prop="login_name">
              <el-input
                v-model.trim="groupRegistryForm.login_name"
                placeholder="Enter Community email"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Association official website URL"
              prop="officalURL"
            >
              <el-input
                v-model.trim="groupRegistryForm.officalURL"
                placeholder="Association official website URL"
              ></el-input>
            </el-form-item>
            <el-form-item prop="schoolId">
              <div class="image-uploader-title">Select your school</div>
              <el-select
                v-model="groupRegistryForm.schoolId"
                placeholder="Select your school name"
                clearable
                @change="selectSchoolChange"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="uploader-box" prop="registerRecord">
              <div class="image-uploader-box">
                <div class="image-uploader-title">
                  Official registration record
                </div>
                <div class="el-upload-box" v-loading="loadingRecordImg">
                  <el-upload
                    class="avatar-uploader"
                    :show-file-list="false"
                    :on-exceed="handleExceed"
                    :before-upload="(file) => beforeAvatarUpload(file, 1)"
                    :on-success="(res) => handleUploadSuccess(res, 1)"
                    :on-error="handleUploadError"
                    :action="getUploadImg + '?ts=' + Date.now()"
                  >
                    <img
                      v-if="groupRegistryForm.registerRecord"
                      :src="groupRegistryForm.registerRecord"
                      class="avatar"
                    />
                    <i
                      class="el-icon-circle-plus"
                      v-if="!groupRegistryForm.registerRecord"
                    ></i>
                    <span
                      v-if="!groupRegistryForm.registerRecord"
                      class="addimg-txt"
                      >Add Images</span
                    >
                  </el-upload>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="group-form-box">
            <div class="group-info-title">Applicant Information</div>
            <el-form-item label="Applicant name" prop="applicantName">
              <el-input
                v-model="groupRegistryForm.applicantName"
                placeholder="Applicant name"
              ></el-input>
            </el-form-item>
            <el-form-item label="Applicant job title" prop="applicantJobTitle">
              <el-input
                v-model="groupRegistryForm.applicantJobTitle"
                placeholder="Applicant job title"
              ></el-input>
            </el-form-item>
            <el-form-item label="Applicant Phone" prop="applicantphone">
              <el-input
                class="applicant-phone"
                v-model="groupRegistryForm.applicantphone"
                placeholder="Enter Applicant Phone"
              >
                <el-select
                  class="country-code"
                  v-model="groupRegistryForm.countrycode"
                  slot="prepend"
                  placeholder="Country Code"
                >
                  <el-option
                    :label="item.countrycode"
                    :value="item.countrycode"
                    v-for="(item, index) in CountryCodeList"
                    :key="index"
                  >
                    <span style="float: left">{{ item.countrycode }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.country }}</span
                    >
                  </el-option>
                </el-select>

                <el-button
                  style="
                    height: 100%;
                    padding-right: 15px;
                    font-size: 14px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #201002;
                  "
                  slot="suffix"
                  type="text"
                  @click="getVerifyCode"
                  :loading="verifyLoading"
                  >verify</el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item label="Verification code" prop="code">
              <el-input
                v-model.trim="groupRegistryForm.code"
                placeholder="Verification code"
              ></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input
                type="password"
                v-model="groupRegistryForm.password"
                placeholder="Enter your password"
              ></el-input>
            </el-form-item>
            <el-form-item class="uploader-box" prop="studentIDImg">
              <div class="image-uploader-box">
                <div class="image-uploader-title">Student ID photo</div>
                <div class="el-upload-box" v-loading="loadingIDImg">
                  <el-upload
                    class="avatar-uploader"
                    :show-file-list="false"
                    :on-exceed="handleExceed"
                    :before-upload="(file) => beforeAvatarUpload(file, 2)"
                    :on-success="(res) => handleUploadSuccess(res, 2)"
                    :on-error="handleUploadError"
                    :action="getUploadImg + '?ts=' + Date.now()"
                  >
                    <img
                      v-if="groupRegistryForm.studentIDImg"
                      :src="groupRegistryForm.studentIDImg"
                      class="avatar"
                    />
                    <i
                      class="el-icon-circle-plus"
                      v-if="!groupRegistryForm.studentIDImg"
                    ></i>
                    <span
                      v-if="!groupRegistryForm.studentIDImg"
                      class="addimg-txt"
                      >Add Images</span
                    >
                  </el-upload>
                </div>
              </div>
              <div class="image-uploader-box">
                <div class="image-uploader-title">ID photo</div>
                <div class="el-upload-box" v-loading="loadingPhotoIDImg">
                  <el-upload
                    :show-file-list="false"
                    :on-exceed="handleExceed"
                    :before-upload="(file) => beforeAvatarUpload(file, 3)"
                    :on-success="(res) => handleUploadSuccess(res, 3)"
                    :on-error="handleUploadError"
                    :action="getUploadImg + '?ts=' + Date.now()"
                  >
                    <img
                      v-if="groupRegistryForm.photoIDImg"
                      :src="groupRegistryForm.photoIDImg"
                      class="avatar"
                    />
                    <i
                      class="el-icon-circle-plus"
                      v-if="!groupRegistryForm.photoIDImg"
                    ></i>
                    <span
                      v-if="!groupRegistryForm.photoIDImg"
                      class="addimg-txt"
                      >Add Images</span
                    >
                  </el-upload>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>

        <div class="regist-bt-box">
          <div
            v-loading="registLoading"
            class="regist-bt"
            @click="toCreateAccount"
          >
            Create group account
          </div>
        </div>
      </div>

      <div class="re-tips">
        Already have an account? <a href="/#/">Log in</a>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../Sys/User.vue";
import { isEmail } from "@/utils/validate";
import { Md5ChangePass, CountryCodeList, scopeDomain } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
import Cookies from "js-cookie";
export default {
  components: { User },
  computed: {
    ...mapState({
      //   xToken: (state) => state.app.token,
    }),
    ...mapGetters(["getUploadImg"]),
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please fill in the email."));
      } else if (!isEmail(value)) {
        callback(new Error("Please enter a valid email."));
      } else callback();
    };
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Please enter phone number"));
      } else {
        callback();
      }
    };
    const validateIDImg = (rule, value, callback) => {
      if (!value || !this.groupRegistryForm.photoIDImg) {
        callback(new Error("Please Upload Student ID photo and ID photo."));
      } else {
        callback();
      }
    };
    const validateIntroduction = (rule, value, callback) => {
      if (!value || value.length < 200 || value.length > 1000) {
        callback(
          new Error(
            "The content length of this introduction is between 200 and 1000"
          )
        );
      } else {
        callback();
      }
    };
    return {
      CountryCodeList: CountryCodeList,
      usertype: 0,
      registryStuType: 0,
      schoolList: [],
      registLoading: false, //注册等待
      loadingRecordImg: false,
      loadingPhotoIDImg: false,
      loadingIDImg: false,
      userPannelStyle: {},
      emailRegistryForm: {},
      groupRegistryForm: {},
      groupRegistryFormRules: {
        applicantphone: [
          {
            required: true,
            message: "Please enter phone number",
            trigger: "blur",
          },
          { required: true, trigger: "blur", validator: validatePhone },
        ],
        societyName: {
          required: true,
          message: "Please fill in the Society name.",
          trigger: "blur",
        },
        maincontent: {
          required: true,
          validator: validateIntroduction,
          trigger: "blur",
        },
        login_name: {
          required: true,
          message: "Please fill in the Community email.",
          trigger: "blur",
        },
        // officalURL: {
        //   required: true,
        //   message: "Please fill in the website URL.",
        //   trigger: "blur",
        // },
        schoolId: {
          required: true,
          message: "Please select your school.",
          trigger: "blur",
        },
        registerRecord: {
          required: true,
          message: "Please Upload Official registration record.",
          trigger: "blur",
        },
        applicantName: {
          required: true,
          message: "Please fill in the Applicant name.",
          trigger: "blur",
        },
        applicantJobTitle: {
          required: true,
          message: "Please fill in the Applicant job title.",
          trigger: "blur",
        },
        code: {
          required: true,
          message: "Please fill in the Verification code.",
          trigger: "blur",
        },
        password: [
          {
            required: true,
            message: "Please fill in the password.",
            trigger: "blur",
          },
        ],
        studentIDImg: {
          required: true,
          trigger: "blur",
          validator: validateIDImg,
        },
      },
      rules: {
        login_name: [
          { required: true, validator: validateEmail, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: "Please fill in the password.",
            trigger: "blur",
          },
        ],
        schoolId: [
          {
            required: true,
            message: "Please make a selection.",
            trigger: "blur",
          },
        ],
      },
      registerInfo: {},
      verifyLoading: false,
    };
  },
  created() {
    this.getSchoolList();
    this.registerInfo = this.$route.query;
    if (
      this.registerInfo.registrytype === "2" ||
      this.registerInfo.registrytype === "3"
    ) {
      this.usertype = 0;
      this.registryStuType = 1;
    }
  },
  mounted() {},
  methods: {
    //自定义密码转文本显示框
    showPass: function (e) {
      let { type } = e.path[3].firstElementChild;
      e.path[3].firstElementChild.type = "text";
    },
    hidePass(e) {
      let { type } = e.path[3].firstElementChild;
      e.path[3].firstElementChild.type = "password";
    },
    chooseUserType(type) {
      this.usertype = type;
      if (type === 0) {
        this.registryStuType = 0;
        this.userPannelStyle = {};
      } else if (type === 1) {
        this.registryStuType = 1;
        this.userPannelStyle = {
          width: "50vw",
        };
      }
    },
    gotoEmail(type) {
      this.registryStuType = type;
    },
    beforeAvatarUpload(file, type) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isJPG && !isPNG) {
        this.$message.error(
          "The uploaded avatar image can only be in JPG or PNG format!"
        );

        return false;
      }
      if (!isLt20M) {
        this.$message.error(
          "The size of the uploaded avatar image cannot exceed 20MB!"
        );
        return false;
      }
      if (type === 1) {
        this.loadingRecordImg = true;
      } else if (type === 2) {
        this.loadingIDImg = true;
      } else if (type === 3) {
        this.loadingPhotoIDImg = true;
      }
      return (isJPG || isPNG) && isLt20M;
    },
    handleExceed(files, fileList) {
      this.$message.error("Only one picture can be uploaded!");
    },
    async handleUploadSuccess(res, type) {
      //获取上传图片地址
      if (res.status === "0") {
        if (type === 1) {
          this.groupRegistryForm.registerRecord = res.data;
          this.loadingRecordImg = false;
          this.$refs.groupRegistryFormRef.clearValidate("registerRecord");
        } else if (type === 2) {
          this.groupRegistryForm.studentIDImg = res.data;
          this.loadingIDImg = false;
          this.$refs.groupRegistryFormRef.clearValidate("studentIDImg");
        } else if (type === 3) {
          this.groupRegistryForm.photoIDImg = res.data;
          this.loadingPhotoIDImg = false;
          this.$refs.groupRegistryFormRef.clearValidate("photoIDImg");
        }
        this.$message.success("Image upload successfully!");
      } else {
        this.$message.error("Image upload failed, please upload again!");
      }
    },
    handleUploadError(err, file, fileList) {
      if (err) {
        this.$message.error(
          "There was an error uploading the image, please try again later！"
        );
      }
    },
    selectSchoolChange(value) {
      if (value) {
        this.$refs.groupRegistryFormRef.clearValidate("schoolId");
      }
    },
    async getVerifyCode() {
      this.$refs.groupRegistryFormRef.validateField(
        "applicantphone",
        async (valid) => {
          if (!valid) {
            this.verifyLoading = true;
            const { status, message } = await this.$api.userApi
              .sendSms({
                phone:
                  this.groupRegistryForm.countrycode +
                  this.groupRegistryForm.applicantphone,
              })
              .catch((err) => {
                this.verifyLoading = false;
              });
            this.verifyLoading = false;
            this.$message({
              type: status === "0" ? "success" : "error",
              message: message,
            });
          } else {
            this.$message({
              type: "warning",
              message: "Please fill in your phone number",
            });
            return false;
          }
        }
      );
    },
    //google授权登录
    logInGoogle() {
      window.location.href =
        "https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&response_type=code&client_id=619151573090-9k02nb4ufr9ufgla1f0brh4mm4gnd5ee.apps.googleusercontent.com&redirect_uri=https://api.coveycampus.com/api/v1.0/coveyuser/googlecallback";
    },
    //facebook授权登录
    logInFacebook() {
      window.location.href =
        "https://www.facebook.com/v13.0/dialog/oauth?client_id=633844777722082&redirect_uri=https://api.coveycampus.com/api/v1.0/coveyuser/facebookcallback";
    },
    async toCreateAccount() {
      this.$refs.groupRegistryFormRef.validate(async (valid) => {
        if (valid) {
          this.registLoading = true;
          let params = { ...this.groupRegistryForm };
          if (this.groupRegistryForm.password) {
            params["password"] = Md5ChangePass(this.groupRegistryForm.password);
          }
          //   console.log("this.groupRegistryForm------", this.groupRegistryForm);
          const { status, message } = await this.$api.userApi.registGroup(
            params
          );
          this.registLoading = false;
          this.$message({
            type: status === "0" ? "success" : "error",
            message: message,
          });
          if (status === "0") {
            this.$store.commit("SET_LOGIN_DIALOG", true);
            this.$router.push({ path: "/" });
          }
        } else {
          this.$message({
            type: "warning",
            message:
              "Please fill in the information completely and try again later",
          });
          return false;
        }
      });
    },
    //获取学校下拉列表
    getSchoolList() {
      this.$api.courseApi.getSchoolList().then((res) => {
        if (res.status === "0") {
          this.schoolList = res.data.rows;
        }
      });
    },
    sleep(duration) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(duration);
        }, duration);
      });
    },
    async registry() {
      try {
        this.$refs["emailRegistryForm"].validate(async (valid) => {
          if (!valid) {
            return;
          }
          this.registLoading = true;
          let param = { ...this.emailRegistryForm };
          if (param.password) {
            param.password = Md5ChangePass(param.password);
          }
          param["login_type"] = this.registryStuType;
          param["usertype"] = this.usertype;
          if (
            this.registerInfo.registrytype === "2" ||
            this.registerInfo.registrytype === "3"
          ) {
            //已授权未注册的用户
            param["first_name"] = this.registerInfo.first_name;
            param["login_name"] = this.registerInfo.id;
            param["last_name"] = this.registerInfo.last_name;
            param["login_type"] = this.registerInfo.registrytype;
            if (this.registerInfo.email) {
              param["email"] = this.registerInfo.email;
            }
          }
          const { status, data, message } = await this.$api.comApi.regist(
            param
          );
          if (status === "0") {
            this.$message({
              type: "success",
              message: "Success!",
            });
            // await this.sleep(3000);
            //登录成功
            Cookies.set(scopeDomain.name, data.token, {
              expires: 3,
              domain: scopeDomain.path,
            }); //设置cookie
            this.$store.commit("setToken", data.token);
            this.$store.commit("handleUserInfo", data.userInfo || {}); // 绑定用户信息
            this.$store.commit("SET_USERINFO", data.userInfo || {}); // 绑定用户信息
            this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
            this.$store.commit("onCallback", true);
            this.$router.push({ path: "/" }); // 登录成功，跳转到对应路由
            this.$store.commit("SET_LOGIN_DIALOG", false);
          } else {
            this.$message.error(message);
          }
          this.registLoading = false;
        });
      } catch (error) {
        console.log(error);
      }
    },
    toHome() {
      this.$router.push("home");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.registry-box {
  min-height: 100vh;
  background: #fce9d1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(28);
  box-sizing: border-box;
  .top-icon {
    text-align: center;
    padding: 28px;
    cursor: pointer;
    img {
      width: 113px;
      height: 40px;
    }
  }
  .user-pannel {
    width: vw(600);
    // height: vw(625);
    background: #fff;
    margin-top: vw(60);
    text-align: center;
    border-radius: 24px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    padding: vh(50) 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .el-form {
      margin-top: vw(16);
      width: 100%;
    }
    .el-form-item {
      margin-bottom: vw(32);
      .forgot-password {
        cursor: pointer;
        float: right;
        font-size: 14px;
        font-weight: 600;
        color: #f48c06;
        line-height: 20px;
      }
    }
    /deep/ .el-form-item.is-error .el-input__inner {
      border-color: #f42506 !important;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__label {
      //label样式
      font-size: 14px;
      font-weight: 600;
      color: #201002;
      line-height: 20px;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__content {
      //   line-height: 100%;
      .el-input {
        margin-top: vw(8);
        .el-input__inner {
          height: vw(48);
          border-radius: 8px;
          border: 2px solid rgba(32, 16, 2, 0.32);
        }
      }
      .el-select {
        width: 100%;
      }
      .el-form-item__error {
        font-size: vw(14);
        font-weight: 600;
        color: #f42506;
      }
    }
    .re-title {
      font-weight: 600;
      color: #201002;
      line-height: vw(66);
      font-size: vw(48);

      font-family: "PingFangSC-Semibold", "PingFang SC";
    }
    .re-sub-title {
      margin-top: vw(16);
      font-size: vw(18);
      line-height: vw(28);
      color: #201002;
      width: vw(500);
    }
    .re-group {
      width: 100%;
      box-sizing: border-box;
      .group-form {
        display: flex;
        .group-form-box {
          flex: 1;
          padding: 0 vw(40);
          /deep/ .el-select {
            width: 100%;
          }
          .image-uploader-title {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #201002;
            line-height: 20px;
            text-align: left;
          }
          /deep/ .el-textarea__inner {
            min-height: 185px !important;
            margin-top: 8px;
            border: 2px solid rgba(32, 16, 2, 0.32) !important;
            font-family: PingFangSC-Semibold, PingFang SC;
          }
          .uploader-box {
            // display: flex;
            // flex-direction: row;
            /deep/ .el-form-item__content {
              // display: flex;
              // flex-direction: row;
            }
          }
          .image-uploader-box {
            // flex: 1 !important;
            margin-bottom: 10px;
            .avatar {
              width: vw(160);
              height: vh(105);
              border-radius: 8px;
            }
            .el-upload-box {
              margin-top: vh(10);
              width: vw(160);
              height: vh(105);
            }
            /deep/ .el-upload {
              width: vw(160);
              height: vh(105);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              background: #f7f6f6;
              color: #b7b2ae;
              border-radius: 8px;
              border: 1px dashed rgba(32, 16, 2, 0.32);
              cursor: pointer;
              .addimg-txt {
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #b7b2ae;
                line-height: 20px;
              }
            }
          }

          .group-info-title {
            text-align: left;
            height: vh(50);
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #201002;
            line-height: vh(50);
            margin-bottom: vh(10);
          }
          /deep/ .el-form-item__label {
            //label样式
            font-size: 14px;
            font-weight: 600;
            color: #201002;
            line-height: 20px;
          }
          /deep/ .el-input {
            margin-top: 8px;
            .el-input__inner {
              height: 48px;
              border-radius: 8px;
              border: 2px solid rgba(32, 16, 2, 0.32);
            }
          }
          /deep/ .el-form-item.is-error .el-input__inner {
            border-color: #f42506 !important;
          }
        }
      }
    }
    .re-status {
      display: flex;
      width: vw(360);
      height: vw(48);
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      border-radius: 24px;
      background: rgba(0, 0, 0, 0.04);
      margin-top: 24px;
      .re-choice {
        width: 50%;
        height: 100%;
        font-size: vw(14);
        padding: vw(14) vw(15);
        line-height: 20px;
        border-radius: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .selected {
        color: #fff;
        background: #f48c06;
        transition: 0.2s;
      }
    }
    .regist-bt-box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .regist-bt {
      width: vw(360);
      height: vw(48);
      font-size: vw(14);
      font-weight: 600;
      border-radius: 8px;
      cursor: pointer;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f48c06;
      &:hover {
        opacity: 0.54;
      }
    }
    .re-third {
      width: vw(360);
      height: vw(48);
      font-size: vw(14);
      font-weight: 600;
      border-radius: 8px;
      margin-top: vw(16);
      cursor: pointer;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: vw(24);
        height: vw(24);
        margin-right: vw(16);
      }
      &:hover {
        opacity: 0.54;
      }
    }
    .re-google {
      background: #5d99fb;
      margin-top: vw(32);
    }
    .re-facebook {
      background: #3b5998;
    }
    .re-email {
      background: #fa6484;
    }
    .re-create {
      background: #f48c06;

      margin-top: vw(56);
    }
    .re-tips {
      font-size: vw(18);
      font-weight: 500;
      color: #201002;
      line-height: vw(28);
      margin-top: vw(32);
      a:link {
        /* 未被访问的链接 蓝色 */
        color: #f48c06;
        text-decoration: none;
      }
      a:visited {
        color: #f48c06;
        text-decoration: none;
      } /* 已被访问过的链接 蓝色 */
      a:hover {
        color: #f48c06;
        text-decoration: none;
      } /* 鼠标悬浮在上的链接 蓝色 */
      a:active {
        color: #f48c06;
        text-decoration: none;
      } /* 鼠标点中激活链接 蓝色 */
    }
  }
  .applicant-phone {
    /deep/.el-input__inner {
      border-left: none !important;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
    /deep/.el-input-group__prepend {
      border: none !important;
    }
  }
  .country-code {
    width: 88px !important;
    /deep/.el-input--suffix {
      margin: 0 !important;
    }
    /deep/.el-input__inner {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      border-top-left-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
      border: 2px solid rgba(32, 16, 2, 0.32) !important;
      border-right: none !important;
    }
  }
}
</style>
